// Documentation module translations - Portuguese (Português)
export const documentationPT = {
  // Common
  'Documentation': 'Documentação',
  'Need Help?': 'Precisa de Ajuda?',
  'Email': 'Email',
  'Documentation Center': 'Centro de Documentação',
  'Check other guides in the Documentation Center': 'Consulte outros guias no Centro de Documentação',
  'If you have questions about payment modes or booking management, our support team is here to help:':
    'Se tiver dúvidas sobre modos de pagamento ou gestão de reservas, nossa equipe de suporte está aqui para ajudar:',

  // Categories
  'Studio Bookings': 'Reservas de Estúdio',
  'Event Setup': 'Configuração de Eventos',
  'Tickets & Pricing': 'Ingressos e Preços',

  // Payment Mode Documentation
  'Payment Mode Management Guide': 'Guia de Gestão de Modos de Pagamento',
  'This comprehensive guide explains how to configure payment modes for your studio bookings and manage the booking approval workflow. Payment modes control how customers pay for their bookings and when money is collected.':
    'Este guia abrangente explica como configurar modos de pagamento para as reservas do seu estúdio e gerenciar o fluxo de aprovação de reservas. Os modos de pagamento controlam como os clientes pagam pelas reservas e quando o dinheiro é coletado.',

  // Overview Section
  'Overview: Understanding Payment Modes': 'Visão Geral: Entendendo os Modos de Pagamento',
  'The system supports four different payment modes, each designed for different business needs:':
    'O sistema suporta quatro modos de pagamento diferentes, cada um projetado para diferentes necessidades de negócio:',

  // Payment Modes
  'Manual Mode': 'Modo Manual',
  'Full Payment Mode': 'Modo Pagamento Completo',
  'Deposit Mode': 'Modo Depósito',
  'Hold Mode': 'Modo Retenção',

  // Payment Mode Labels
  'No online payment': 'Sem pagamento online',
  'Instant charge': 'Cobrança instantânea',
  'Partial charge': 'Cobrança parcial',
  'Authorization hold': 'Retenção de autorização',

  // Payment Mode Descriptions
  'Customer submits booking request without paying online. Owner approves, then collects payment later (cash, invoice, etc.)':
    'O cliente envia pedido de reserva sem pagar online. O proprietário aprova e depois coleta o pagamento mais tarde (dinheiro, fatura, etc.)',
  'Customer pays 100% upfront via online payment. Booking is automatically confirmed once payment succeeds.':
    'O cliente paga 100% antecipadamente via pagamento online. A reserva é confirmada automaticamente quando o pagamento é bem-sucedido.',
  'Customer pays a deposit upfront (e.g., 30%). Remaining balance collected later (before/after session).':
    'O cliente paga um depósito antecipadamente (ex: 30%). O saldo restante é coletado mais tarde (antes/depois da sessão).',
  'Card is authorized but NOT charged. Owner approves booking → money is captured. Owner rejects → hold is released.':
    'O cartão é autorizado mas NÃO cobrado. O proprietário aprova a reserva → o dinheiro é capturado. O proprietário rejeita → a retenção é liberada.',

  // Configuration Section
  'How to Configure Payment Settings': 'Como Configurar as Definições de Pagamento',
  'Payment settings are configured per studio in the Manage Settings page under the Pricing & Payment tab. Navigate to: Studios → [Your Studio] → Manage Settings → Pricing & Payment':
    'As definições de pagamento são configuradas por estúdio na página Gerenciar Configurações sob a aba Preços e Pagamentos. Navegue para: Estúdios → [Seu Estúdio] → Gerenciar Configurações → Preços e Pagamentos',

  // Configuration Steps
  'Access Payment Settings': 'Acessar Configurações de Pagamento',
  'Select Payment Mode': 'Selecionar Modo de Pagamento',
  'Configure Deposit Settings (if using Deposit Mode)': 'Configurar Definições de Depósito (se usar Modo Depósito)',
  'Configure Booking Rules': 'Configurar Regras de Reserva',
  'Save Your Changes': 'Salvar suas Alterações',

  // Booking Management
  'Managing Booking Requests': 'Gestão de Pedidos de Reserva',
  'Understanding Booking Statuses': 'Entendendo os Status de Reserva',
  'Understanding Payment Statuses': 'Entendendo os Status de Pagamento',

  // Workflow
  'Workflow: Approving Bookings (Manual & Hold Modes)': 'Fluxo de Trabalho: Aprovação de Reservas (Modos Manual e Retenção)',
  'View Pending Approvals': 'Ver Aprovações Pendentes',
  'Review Booking Details': 'Revisar Detalhes da Reserva',
  'Approve the Booking': 'Aprovar a Reserva',
  'Reject the Booking (if needed)': 'Rejeitar a Reserva (se necessário)',

  // Best Practices
  'Best Practices & Tips': 'Melhores Práticas e Dicas',
  'Choose the Right Mode for Your Business': 'Escolha o Modo Certo para o Seu Negócio',
  'Respond to Booking Requests Quickly': 'Responda aos Pedidos de Reserva Rapidamente',
  'Provide Clear Rejection Reasons': 'Forneça Razões de Rejeição Claras',
  'Set Appropriate Deposit Amounts': 'Defina Valores de Depósito Apropriados',
  'Monitor Your Booking Dashboard': 'Monitore seu Painel de Reservas',
  'Track Your Revenue': 'Acompanhe sua Receita',

  // Quick Reference
  'Quick Reference: Payment Mode Comparison': 'Referência Rápida: Comparação de Modos de Pagamento',

  // Table Headers and Common Terms
  'Status': 'Status',
  'What It Means': 'O Que Significa',
  'Payment Status': 'Status de Pagamento',
  'Actions Available': 'Ações Disponíveis',
  'Feature': 'Recurso',
  'Manual': 'Manual',
  'Full Payment': 'Pagamento Completo',
  'Deposit': 'Depósito',
  'Hold': 'Retenção',
  'Best For': 'Melhor Para',
  'Mode': 'Modo',

  // Payment Statuses
  'Unpaid': 'Não Pago',
  'Pending': 'Pendente',
  'On Hold': 'Em Retenção',
  'Deposit Paid': 'Depósito Pago',
  'Paid': 'Pago',
  'Refunded': 'Reembolsado',

  // Booking Statuses
  'Pending Approval': 'Aprovação Pendente',
  'Confirmed': 'Confirmado',
  'In Progress': 'Em Andamento',
  'Completed': 'Concluído',
  'Rejected': 'Rejeitado',
  'Cancelled': 'Cancelado',
  'No Show': 'Não Compareceu',

  // Actions
  'Approve': 'Aprovar',
  'Reject': 'Rejeitar',
  'View': 'Ver',
  'Cancel': 'Cancelar',
  'Mark In Progress': 'Marcar Em Andamento',
  'Mark Completed': 'Marcar Concluído',
  'Collect Balance': 'Coletar Saldo',

  // Common Descriptions
  'No payment received yet. Common in manual mode bookings before collection.':
    'Nenhum pagamento recebido ainda. Comum em reservas de modo manual antes da cobrança.',
  'Payment initiated but not completed. Customer in checkout process.':
    'Pagamento iniciado mas não concluído. Cliente em processo de checkout.',
  'Full payment received and confirmed. No balance owed.':
    'Pagamento completo recebido e confirmado. Sem saldo devido.',
  'Payment was refunded back to customer (full or partial refund).':
    'O pagamento foi reembolsado ao cliente (reembolso total ou parcial).',
};
